import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { schemaIsScalar } from '@integration-app/sdk';
import { Field, FieldActionBar, FieldPropertiesList } from './components/Field';
import { NestedLevel } from './components/NestedLevel';
import { AddLevelButton } from './components/NestedLevel/AddLevelButton';
import { Cell, Row, Title } from './components/Row';
import ObjectProperties from './ObjectProperties';
import { useSchemaBuilderContext } from './SchemaContext';
import useEventStopPropagation from '../hooks/useEventStopPropagation';
export default function Schema({ name, schema, isRequired = false, level, onChange, onNameChange, onRequiredChange, onDelete, onAdd, deprecatedNames, }) {
    var _a;
    const { referenceCollections, readOnly, isObject } = useSchemaBuilderContext();
    const { type, items, properties, $ref, ...schemaProperties } = schema !== null && schema !== void 0 ? schema : {};
    function handlePropertiesChange(value) {
        onChange({
            type,
            items,
            properties,
            $ref,
            ...(value !== null && value !== void 0 ? value : {}),
        });
    }
    function handleEscKey(value) {
        if (!value) {
            onDelete === null || onDelete === void 0 ? void 0 : onDelete();
        }
    }
    function handleEnterKey() {
        onAdd === null || onAdd === void 0 ? void 0 : onAdd();
    }
    const propertiesSchema = getPropertiesSchema(schema, {
        referenceCollections,
    });
    function handlePropertyAdd() {
        onChange({
            ...structuredClone(schema),
            properties: {
                ...structuredClone(schema.properties),
                ['']: {
                    type: 'string',
                },
            },
        });
    }
    function patchSchema(patch) {
        onChange({
            ...(schema !== null && schema !== void 0 ? schema : {}),
            ...patch,
        });
    }
    return (_jsxs(_Fragment, { children: [(level > 0 || (schema === null || schema === void 0 ? void 0 : schema.type) !== 'object' || !isObject) && (_jsx(NestedLevel, { level: level, children: _jsxs(Row, { children: [_jsx(Cell.Name, { grow: true, children: _jsx(Title, { children: _jsx(Field, { schema: schema, name: name, onChange: onChange, onEnter: handleEnterKey, onEsc: handleEscKey, onNameChange: onNameChange, deprecatedNames: deprecatedNames, level: level }) }) }), !readOnly && (_jsx(FieldActionBar, { onDelete: onDelete, name: name, schema: schema, properties: schemaProperties, propertiesSchema: propertiesSchema, isRequired: isRequired, onPropertiesChange: handlePropertiesChange, onRequiredChange: onRequiredChange })), _jsx(FieldPropertiesList, { propertiesSchema: propertiesSchema, properties: schemaProperties, isRequired: isRequired })] }) })), (schema === null || schema === void 0 ? void 0 : schema.type) === 'object' && (_jsxs(_Fragment, { children: [_jsx(ObjectProperties, { schema: schema, onAdd: handlePropertyAdd, level: level + 1, onChange: onChange }), !readOnly && (_jsx(AddLevelButton, { field: { level, name }, onAdd: useEventStopPropagation(handlePropertyAdd) }))] })), (schema === null || schema === void 0 ? void 0 : schema.type) === 'array' && (_jsx(_Fragment, { children: _jsx(Schema, { name: 'item', schema: (_a = schema.items) !== null && _a !== void 0 ? _a : {}, level: level + 1, onChange: (items) => patchSchema({ items }) }) }))] }));
}
function getPropertiesSchema(schema, { referenceCollections, }) {
    const propertiesSchema = {
        type: 'object',
        properties: {
            title: {
                type: 'string',
            },
            description: {
                type: 'string',
            },
            default: {
                ...schema,
                title: 'Default',
            },
        },
    };
    if (schemaIsScalar(schema)) {
        propertiesSchema.properties.enum = {
            type: 'array',
            items: {
                type: schema.type,
            },
        };
        propertiesSchema.properties.referenceRecords = {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    name: { type: 'string' },
                },
            },
        };
        if ((schema === null || schema === void 0 ? void 0 : schema.enum) || (schema === null || schema === void 0 ? void 0 : schema.referenceRecords)) {
            propertiesSchema.properties.allowCustom = {
                type: 'boolean',
            };
        }
    }
    if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'string') {
        propertiesSchema.properties.format = {
            type: 'string',
            enum: [
                'date-time',
                'date',
                'time',
                'email',
                'hostname',
                'ipv4',
                'ipv6',
                'uri',
            ],
        };
        propertiesSchema.properties.minLength = {
            type: 'number',
        };
        propertiesSchema.properties.maxLength = {
            type: 'number',
        };
    }
    if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'number') {
        propertiesSchema.properties.minimum = {
            type: 'number',
        };
        propertiesSchema.properties.maximum = {
            type: 'number',
        };
    }
    if (schemaIsScalar(schema) && (referenceCollections === null || referenceCollections === void 0 ? void 0 : referenceCollections.length)) {
        propertiesSchema.properties.referenceCollection = {
            type: 'object',
            properties: {
                key: {
                    type: 'string',
                    enum: referenceCollections.map((collection) => collection.key),
                    allowCustom: true,
                },
                parameters: {
                    type: 'object',
                    additionalProperties: true,
                },
            },
            required: ['key'],
        };
    }
    propertiesSchema.properties.readOnly = {
        type: 'boolean',
    };
    propertiesSchema.properties.writeOnly = {
        type: 'boolean',
    };
    if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'object') {
        propertiesSchema.properties.additionalProperties = {
            type: 'boolean',
        };
    }
    return propertiesSchema;
}
//# sourceMappingURL=Schema.js.map